import GiftCategories from '@/models/loyaltyPanel/GiftCategories';
const getDefaultState = () => ({
  gifts: [],
  giftCategories: [],
  gift: new GiftCategories(),
  deleteDialog: false,
  closeForm: false,
});
export default {
  namespaced: true,

  state: () => getDefaultState(),

  getters: {
    getGiftCategories(state) {
      return state.giftCategories;
    },
    getDeleteDialog(state) {
      return state.deleteDialog;
    },
    getGift(state) {
      return state.gift;
    },
    getCloseForm(state) {
      return state.closeForm;
    },
  },

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setGifts(state, payload) {
      state.gifts = payload;
    },
    setGiftCategories(state, payload) {
      state.giftCategories = payload;
    },
    setGiftData(state, payload) {
      state.gift = new GiftCategories(payload);
    },
    setDeleteDialog(state, payload) {
      state.deleteDialog = payload;
    },
    setCloseForm(state, payload) {
      state.closeForm = payload;
    },
  },

  actions: {
    async fetchGifts({ commit }) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await GiftCategories.get();

        const gifts = data.data.gifts;
        commit('setGifts', gifts);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async fetchGiftCategories({ commit }, query) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await GiftCategories.getCategories(query);
        const { gift_categories, pagination } = data.data;

        commit('setGiftCategories', gift_categories);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async fetchGiftData({ commit }, id) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await GiftCategories.getGift(id);
        const gift = data.data;

        // commit("setGiftData", gift);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async create({ commit, dispatch }, body) {
      try {
        commit('setLoading', true, { root: true });
        if (body.supplier_store_id == null || body.gift_type_id == 2) {
          delete body.supplier_store_id;
        }

        if (body.gift_type_id == 1) {
          delete body.redeem_company_ids;
        }

        const name = {
          en: body.name.en || body.name.el || body.name.it,
          el: body.name.el || body.name.en || body.name.it,
          it: body.name.it || body.name.en || body.name.el,
        };
        const item = {
          name: name,
          bg_color: body.bg_color,
          text_color: body.text_color,
        };
        const { data } = await GiftCategories.create(item);
        if (body.upload) {
          const id = data.data.gift_category.gift_category_id;
          const fd = new FormData();
          fd.append('image', body.upload);
          await GiftCategories.uploadImage(id, fd);
        }

        dispatch('fetchGiftCategories', '?page=1');
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully Created a new category!',
          },
          { root: true }
        );
        commit('setCloseForm', true);
        setTimeout(() => commit('setCloseForm', false), 10);
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, { root: true });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async update({ commit, dispatch }, body) {
      try {
        commit('setLoading', true, { root: true });
        const name = {
          en: body.name.en || body.name.el || body.name.it,
          el: body.name.el || body.name.en || body.name.it,
          it: body.name.it || body.name.en || body.name.el,
        };
        const item = {
          name: name,
          bg_color: body.bg_color,
          text_color: body.text_color,
          image: body.image,
        };
        const id = body.gift_category_id;
        await GiftCategories.update(id, item);
        if (body.upload) {
          const fd = new FormData();
          fd.append('image', body.upload);
          await GiftCategories.uploadImage(id, fd);
        }
        dispatch('fetchGiftCategories', '?page=1');
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully Updated a category!',
          },
          { root: true }
        );
        commit('setCloseForm', true);
        setTimeout(() => commit('setCloseForm', false), 10);
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, { root: true });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async delete({ commit, dispatch }, id) {
      try {
        commit('setLoading', true, { root: true });

        await GiftCategories.delete(id);

        dispatch('fetchGiftCategories', '?page=1');
        commit('setDeleteDialog', false);
        commit('setLoading', false, { root: true });
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'The Category is successfully deleted!',
          },
          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },
  },
};
